import { render, staticRenderFns } from "./add.vue?vue&type=template&id=e074f11c&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&lang=less&"
import style1 from "./add.vue?vue&type=style&index=1&id=e074f11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e074f11c",
  null
  
)

export default component.exports